import { PayloadAction } from '@reduxjs/toolkit';
import { getConfigBaseUrl, getIAMBaseUrl } from '../../services/apiService';
import { getCounterpartyId } from '../../services/authService';
import { apiCall, createApiThunk } from '../../utils/api';
import { LoginState } from './loginSlice';

export const getTenantConfigThunk = createApiThunk('GET_TENANT_CONFIG', apiCall);

export const getCognitoClientID = (tenantCode: string) => {
  const url = `${getIAMBaseUrl()}/webclients/${tenantCode}`;
  return apiCall({ url });
};

export const getTenantConfig = (tenantId?: string) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      getTenantConfigThunk({
        url: `${getConfigBaseUrl()}/v2/config/tenants/${tenantId || getCounterpartyId()}/tenant-config`,
        method: 'GET',
      }),
    );
  };
};

export const setUser = (state: LoginState, action: PayloadAction<any>) => {
  state.user = action.payload;
};

export const toggleForceLogout = (state: LoginState) => {
  state.forcedLogout = !state.forcedLogout;
};

export const clearTenantConfig = (state: LoginState) => {
  state.tenantConfig = null;
};
